import anime from 'animejs';
import wave from './wave';
import { qs, qsa } from '@/scripts/utils';


const picture = (el) => {
  const bg = qs('[js-target="picturebg"]', el);
  const images = qsa('[js-target="pictureimg"]', el);
  images.forEach(el => el.removeAttribute('js-target'));
  const rotation = el.getAttribute('js-rotation');
  // el.removeAttribute('js-rotation');

  const lottie = el.getAttribute('js-lottie');
  el.removeAttribute('js-lottie');

  const orientation = el.getBoundingClientRect().left > (window.innerWidth - el.getBoundingClientRect().right) ? 1 : -1;
  const translatePhoto = 50 * orientation;
  const translateBg = 50 * orientation * -1;

  const basicTimeline = anime.timeline();

  basicTimeline.add({
    targets: el,
    duration: 0,
    opacity: 1,
    offset: 0
  })
  .add({
    targets: images,
    duration: 750,
    opacity: [0, 1],
    translateX: [translatePhoto, 0],
    translateY: [170, 0],
    translateZ: 0,
    scale: [0.8, 0.8],
    rotateZ: ['0deg', `${rotation}deg`],
    easing: 'easeInOutSine',
    offset: 0,
  });

  if (bg !== null) {
    let isAnimated = false;
    basicTimeline.add({
      targets: bg,
      duration: 750,
      opacity: [0, 1],
      translateX: [translatePhoto, 0],
      translateY: [170, 0],
      translateZ: 0,
      rotateZ: ['4deg', '0deg'],
      easing: 'easeInOutSine',
      offset: 0,
      run: (anim) => {
        if (Math.round(anim.progress) > 20 && !isAnimated) {
          isAnimated = true;
          if (lottie !== 'speakers') {
            wave(bg, lottie).play();
          } else {
            const speaker = wave(bg, lottie);
            speaker.playSegments([0, 25], false);
          }
        }
      },
    });
  }

  return basicTimeline;
}

export default picture;
